import { Directive, TemplateRef } from '@angular/core';

@Directive({ selector: 'ng-template[appTabContent]' })
export class ContentDirective {
    public constructor(public templateRef: TemplateRef<unknown>) {}
}
